import { Avatar, Grid, Typography } from '@mui/material'

type SingleCommentProps = {
  id: number
  content: string
  name: string
  profilePicture: string
}

const SingleComment = ({ id, content, name, profilePicture }: SingleCommentProps) => {
  return (
    <div className='div'>
      <Grid container justifyContent='space-between' alignItems='center' mb={5}>
        <Grid display='flex' alignItems='center' item>
          <Avatar src={profilePicture} sx={{ width: 30, height: 30 }} />
          <Typography variant='h4' pl={2}>
            {name} {id}
          </Typography>
        </Grid>
        <Grid container mt={1}>
          <Grid xs={12}>
            <Typography variant='h5' pl={6}>
              {content}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default SingleComment
